import { useEffect, useState } from 'react';
import axios, { all } from 'axios';
import { base_url } from '../../api/api-url';
import { Box ,Button} from '@mui/material';


async function createDepartment() {
  try {
    const response = await axios.post(`${base_url}/department`, {
      label: "IT Team",
      description: "IT Team"
    });
    const department = response.data.data || response.data;
    console.log("✅ Department created:", department.label);
    return department;
  } catch (error) {
    console.error("❌ Department creation failed:", error.response?.data || error.message);
    return null;
  }
}

async function createAdminUser(department) {
  try {
    const userPayload = {
      staffID: "1",
      fullName: "adminTest",
      email: "admin@gmail.com",
      mobile: "987654321",
      department: [department],
      allowedModule: ["Dashboard","Departments","Staff Management","User","Clients","Vendors","Category","Tickets","Reports"],
      role: "Admin",
      password: "123456"
    };

    const response = await axios.post(`${base_url}/user-register`, userPayload);
    console.log("✅ Admin user created:", response.data.fullName || response.data);
  } catch (error) {
    console.error("❌ Admin user creation failed:", error.response?.data || error.message);
  }
}

function DevInit() {
  const [apiCall,setApiCall]=useState(false)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const isDev = params.get('dev');

    if (isDev === 'true'||apiCall) {
   
      (async () => {
        const department = await createDepartment();
        if (department) {
          await createAdminUser(department);
        }
      })();
    }
  }, [apiCall]);

  return(
    <Box sx={{
      display:"none",
      position:"absolute",top:0
    }}>
      <Button onClick={()=>setApiCall(true)} variant='contained' >dev settings</Button>
    
    </Box>
  );
}

export default DevInit;
